import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SettingsItem} from '../../models/settingsItem';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  public items: SettingsItem[] = [];
  pageTitle: string;

  constructor(public router: Router) {
    this.pageTitle = 'Ρυθμίσεις';
    const userManagement: SettingsItem = {
      title: 'Διαχείριση χρηστών',
      description: 'Εμφάνιση λίστας χρηστών',
      imgPath: 'assets/images/parents2.png',
      navigationPath: 'home/parents'
    };

    const studentManagement: SettingsItem = {
      title: 'Διαχείριση χρηστών',
      description: 'Εμφάνιση λίστας χρηστών',
      imgPath: 'assets/images/students.png',
      navigationPath: 'home/students'
    };

    const formManagement: SettingsItem = {
      title: 'Διαχείριση δηλώσεων',
      description: 'Εμφάνιση και διαχείριση λίστας δηλώσεων',
      imgPath: 'assets/images/forms.png',
      navigationPath: 'home/forms'
    };

    const affirmationsManagement: SettingsItem = {
      title: 'Διαχείριση Δηλώσεων',
      description: 'Εμφάνιση και διαχείριση λίστας δηλώσεων',
      imgPath: 'assets/images/questions.png',
      navigationPath: 'home/affirmations'
    };


    const roleManagement: SettingsItem = {
      title: 'Διαχείριση Ρόλων',
      description: 'Διαχείριση ενεργειών χρηστών',
      imgPath: 'assets/images/roles2.png',
      navigationPath: 'home/roles-management'
    };

    const emailLogsManagement: SettingsItem = {
      title: 'Email Logs',
      description: 'Προβολή αρχείου αποστολής email',
      imgPath: 'assets/images/roles2.png',
      navigationPath: 'home/email-logs'
    };

    const smsLogsManagement: SettingsItem = {
      title: 'Sms Logs',
      description: 'Προβολή αρχείου αποστολής sms',
      imgPath: 'assets/images/roles2.png',
      navigationPath: 'home/sms-logs'
    };

    // const consentManagement: SettingsItem = {
    //   title: 'Διαχείριση Ερωτήσεων Συναίνεσης',
    //   description: 'Εμφάνιση λίστας ερωτήσεων',
    //   imgPath: 'assets/images/questions.png',
    //   navigationPath: 'home/consents-questions'
    // };
    //
    // const activitiesManagement: SettingsItem = {
    //   title: 'Διαχείριση Δραστηριοτήτων',
    //   description: 'Εμφάνιση λίστας δραστηριοτήτων',
    //   imgPath: 'assets/images/questions.png',
    //   navigationPath: 'home/activities'
    // };
    //
    // const activitiesLevelManagement: SettingsItem = {
    //   title: 'Διαχείριση Επιπέδων δραστηριοτήτων',
    //   description: 'Εμφάνιση λίστας επιπέδων δραστηριοτήτων',
    //   imgPath: 'assets/images/questions.png',
    //   navigationPath: 'home/activities-level'
    // };

    const siteManagement: SettingsItem = {
      title: 'Διαχείριση Κολλεγίου',
      description: 'Διαχείριση πληροφοριών κολλεγίου',
      imgPath: 'assets/images/settings.png',
      navigationPath: 'home/college-management'
    };

    const logs: SettingsItem = {
      title: 'Αρχείο κινήσεων',
      description: 'Εμφάνιση λίστας γονέων',
      imgPath: 'assets/images/logs2.png',
      navigationPath: 'home/logs'
    };

    const userConfirmation: SettingsItem = {
      title: 'Διαχείριση επιβεβαίωσης εκκρεμών χρηστών',
      description: 'Εμφάνιση λίστας χρηστών προς επιβεβαίωση',
      imgPath: 'assets/images/logs2.png',
      navigationPath: 'home/user-confirmation'
    };

    // this.items.push(siteManagement, userConfirmation, userManagement, studentManagement, formManagement, roleManagement, consentManagement, activitiesManagement, activitiesLevelManagement,  logs);
    this.items.push(siteManagement, userConfirmation, userManagement, studentManagement, formManagement, roleManagement, emailLogsManagement, smsLogsManagement, logs);

  }

  ngOnInit(): void {
  }

  async navigate(navigationPath: string) {
    await this.router.navigate([navigationPath]);
  }
}
